const keyCodes = {
  TAB: 9,
  RETURN: 13,
  ESC: 27,
  SPACE: 32,
  PAGEUP: 33,
  PAGEDOWN: 34,
  END: 35,
  HOME: 36,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  ENTER: 13,
};

const simulateKeyEvent = character => {
  const webkEvt = new KeyboardEvent('keypress', { keyCode: '9' });
  if (webkEvt) {
    document.dispatchEvent(webkEvt);
  } else {
    const evt = document.createEvent('KeyboardEvent');
    (evt.initKeyEvent || evt.initKeyboardEvent)(
      'keypress',
      true,
      true,
      window,
      0,
      0,
      0,
      0,
      0,
      character.charCodeAt(0)
    );
    const canceled = !window.dispatchEvent(evt);
    if (canceled) {
      // A handler called preventDefault
      // alert('canceled');
    } else {
      // None of the handlers called preventDefault
      // alert('not canceled');
    }
  }
};

const createElementFromHTML = htmlString => {
  var div = document.createElement('div');
  div.innerHTML = htmlString.trim();
  return div.firstChild;
}

// returns an array of values by their key in an array
const findUniqueValuesIn = (array, key) => {
  //console.log(array, key)
  const values = array.map(val => {
    return val[key]
  })
  return Array.from(new Set(values));
}

export {
  keyCodes,
  simulateKeyEvent,
  createElementFromHTML,
  findUniqueValuesIn
};
